module.exports = __webpack_public_path__ + "static/media/invoice_subscription_help_v2.9a67256c.png";